import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext'; // Import useTheme
import { getUserProfile, updateUserPreferences } from '../../services/authService';

const UserProfile = () => {
  // Get user and updateUserData from AuthContext
  const { currentUser, updateUserData } = useAuth(); 
  // Get setSpecificTheme from ThemeContext
  const { setSpecificTheme } = useTheme(); 
  const [profile, setProfile] = useState(null);
  // Initialize theme preference from localStorage or user data
  const [preferences, setPreferences] = useState(() => {
    const savedUser = JSON.parse(localStorage.getItem('user'));
    return savedUser?.preferences || { theme: localStorage.getItem('theme') || 'light' };
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      setIsLoading(true);
      setError('');
      try {
        let userData = currentUser;
        if (!userData) {
          // Fetch fresh profile if not available in AuthContext
          userData = await getUserProfile();
          updateUserData(userData); // Update AuthContext
        }
        setProfile(userData);
        // Set initial preferences from fetched/context user data
        setPreferences(userData.preferences || { theme: localStorage.getItem('theme') || 'light' });
      } catch (err) {
        setError(err.message || 'Failed to load profile');
      } finally {
        setIsLoading(false);
      }
    };
    fetchProfile();
  }, [currentUser, updateUserData]); // Depend on currentUser from AuthContext

  // const handlePreferenceChange = (e) => {
  //   const { name, value } = e.target;
  //   setPreferences((prev) => ({ ...prev, [name]: value }));
  // };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      // Pass only preferences to the update function
      const updatedUserData = await updateUserPreferences(preferences);
      console.log('UserProfile: API response from updateUserPreferences:', updatedUserData); // <-- ADD THIS LOG
      
      // Update profile state and AuthContext state
      setProfile(prevProfile => ({ ...prevProfile, preferences: updatedUserData.preferences }));
      updateUserData(updatedUserData); // Update user data in AuthContext
      setPreferences(updatedUserData.preferences); // Update local preferences state

      // Apply the theme *after* successful update using ThemeContext
      if (updatedUserData.preferences?.theme) {
        setSpecificTheme(updatedUserData.preferences.theme);
      }
      
      // Optionally add a success message state here

    } catch (err) {
      setError(err.message || 'Failed to update profile');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>Loading profile...</div>;
  }
  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <h2>User Profile</h2>
      <div>
        <p><strong>Username:</strong> {profile?.username}</p>
        <p><strong>Email:</strong> {profile?.email}</p>
      </div>
      <form onSubmit={handleUpdateProfile}>
        <div>
          {/* <label htmlFor="theme">Theme Preference</label>
          <select
            id="theme"
            name="theme"
            value={preferences.theme} // Ensure this reflects the state
            onChange={handlePreferenceChange}
          >
            <option value="light">Light</option>
            <option value="dark">Dark</option>
            <option value="island">Island</option>
          </select>
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Update Preferences'}
        </button>
        {error && <p style={{ color: 'red' }}>Error: {error}</p>} */}
        </div>
      </form>
    </div>
  );
};

export default UserProfile;